


























































































































    import TagModal from "../../Components/ComponentsBase/BaseTLModalDialogTag.vue";
	import { Vue, Component, Prop, TagService, TagFilter, AxiosResponse, ObjectTypesHelper } from "../../Infrastructure/CorBase/CoreBase";
	import { IContentService, ServicesFactory } from "../../Infrastructure/ServicesFactory";
    import ModalDetail from "../../Components/ComponentsBase/BaseTLModalDialogDetail.vue";
	interface TaskOne {
		Id: number;
		Name: string;
	}

	//VaPTODO - predelat na ObjectTypesHelper a jeho metody isContentObjectType a isReceiverObjectType misto primeho porovnani zde

	@Component({
		components: {
			Keypress: () => import('vue-keypress')
		}
	})
	export default class BaseTLModalDialogPopUp extends Vue {
		@Prop({ type: String, required: true, default: "" }) id!: string;
		@Prop({ type: Number, required: false, default: ObjectTypesHelper.ObjectTypeEnum.Content }) objectType5?: ObjectTypesHelper.ObjectTypeEnum = ObjectTypesHelper.ObjectTypeEnum.Content;
      //  @Prop({ type: Object, required: false, default: null }) item?: any;  //

		objectContent = ObjectTypesHelper.ObjectTypeEnum.Content;
		objectReceiver = ObjectTypesHelper.ObjectTypeEnum.Receiver;

		tagService: TagService = new TagService();
		contentService: IContentService | null = ServicesFactory.getContentService();
		options = [];
		selectedItems = [];
		idComponent = 0;
		listItems: any;
		actualItem: any = null;
		idItem: number = 0;
		actualIndex: number = 0;
		isBusy: boolean = false;
		alertModalId: string = 'alertModalIdPopUp';
		alertModalTitle: string = '';
		alertModalContent: string = '';

		orderBy: string = '';
		orderDesc: boolean = false;

		showVideoTag = false;
		showAudioStreamTag = false;
		isDownloadVideo = false;
		pathToVideo = '';

        changeTags(items: any): void {
            this.actualItem.tags = items;
		}

		lastIdComponent = 0;
		addNewTag(item: any) {
            this.$bvModal.show('tagDialogPop');
			this.lastIdComponent = Number(item.id);
            (this.$refs.tagDialogPop as TagModal).setSelected(item.tags, this.lastIdComponent, item.name);
        }

		typeObjectTag() {
			return this.objectType == ObjectTypesHelper.ObjectTypeEnum.Content ? 'content' : 'receiver';
		}

        tagDetail(item: any): void {
            this.$bvModal.show('tagDialogPop');
			(this.$refs.tagDialogPop as ModalDetail).setSelected(String(item.id));
            //(this.$refs.tagDialogPop as TagModal).setSelected(item.tags, this.id, item.name);
        }
		
		private allowPlayMedium(): boolean {
			var result = this.actualItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_Video' ||
				this.actualItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_AudioStream' ||
                this.actualItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_Audio';
			return result;
        }

		private playMedia(): void {
			//audio stream
			if (this.allowPlayMedium()) {
				if (this.actualItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_AudioStream') {
					var audioTag = document.getElementById('audioStream');
					(audioTag as HTMLAudioElement).src = this.actualItem.url;
					(audioTag as HTMLAudioElement).play();
					this.showAudioStreamTag = true;
				}
				else if (this.showDownloadButton()) {
					if (this.isDownloadVideo) {
						this.showVideoTag = true;
						var videoTag = document.getElementById('vidObj');
						(videoTag as HTMLVideoElement).play();
						this.isPlayVideo();
					}
					else {
						this.downloadFileForPlay();
					}
				}
			}
			else if (this.actualItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_LinkToUrl') {
                window.open((this.actualItem.url).toString(), '_blank');
            }
		}

		private showCursor() {
            var result = this.actualItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_Video' ||
				this.actualItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_AudioStream' ||
                this.actualItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_LinkToUrl' ||
				this.actualItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_Audio';
			return result;
        }

        
        private stopMedia(): void {
            if (this.showDownloadButton()) {
                if (this.isDownloadVideo) {
                    var videoTag = document.getElementById('vidObj');
					(videoTag as HTMLVideoElement).pause();
					(videoTag as HTMLVideoElement).currentTime = 0;
                }
			}
			if (this.actualItem != null && this.actualItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_AudioStream') {
				var audioTag = document.getElementById('audioStream');
				(audioTag as HTMLAudioElement).currentTime = 0;
				(audioTag as HTMLAudioElement).pause();
            }
        }

		get inputClass() {
            return { "showCursorPointer": this.showCursor() }
		}

		private downloadFileForPlay(): void {
			if (this.contentService != null) {
				this.isBusy = true;
				this.showVideoTag = true;
				this.contentService.getOriginalFileById(this.actualItem.id).then((response) => {
					var myUrl = (window.URL || window.webkitURL).createObjectURL(new Blob([response.data]));
					this.pathToVideo = myUrl;
					var videoTag = document.getElementById('vidObj');
					(videoTag as HTMLVideoElement).src = this.pathToVideo;
					this.isPlayVideo();
					this.isDownloadVideo = true;
					this.isBusy = false;
				}).catch((error) => {
					this.showVideoTag = this.isDownloadVideo = false;
					if (this.fileNotFound(error)) {
						this.showErrorMessage('Soubor nenalezen');
					} else {
						this.showErrorMessage(JSON.stringify(error.response.data.errors));
					}
					this.isBusy = false;
				});
			}
		}

		intervalId = 0;
		private isPlayVideo() {
			this.intervalId = setInterval(this.testPlayVideo, 1000);
		}

		private testPlayVideo() {
			var videoTag = document.getElementById('vidObj');
			if (videoTag == null) {
				clearInterval(this.intervalId);
			}
			else {
				var endVideoPlay = (videoTag as HTMLVideoElement).ended;
				if (endVideoPlay) {
					clearInterval(this.intervalId);
					this.showVideoTag = false;
				}
			}
		}

		private changePicture(): void {
			this.stopMedia();
			this.isDownloadVideo = false;
			this.showVideoTag = this.showAudioStreamTag = false;
			clearInterval(this.intervalId);
		}

		beforeDestroy() {
            this.isDownloadVideo = false;
            this.showVideoTag = this.showAudioStreamTag = false;
			clearInterval(this.intervalId);
		}

		//VaP - zatim resime pouze Content, casem pridame i receiver a nejsi i dalsi stranky
		//    - podle objectType pak bude potreba upravit nektere zobrazene texty a volane metody
		objectType: ObjectTypesHelper.ObjectTypeEnum = ObjectTypesHelper.ObjectTypeEnum.None;
		get isContentModal(): boolean {
			return ObjectTypesHelper.isContentObjectType(this.objectType);
		}

		////TODO udelat lepe - na dvou mistech
		prepareIdBasePreview(data: any) {
			if (data == null) {
				return 0;
			}
			return data;
		}

		private getPreviewId(id: number | null | undefined): string {
			if (id && id > 0) {
				if (ObjectTypesHelper.isContentObjectType(this.objectType)) {
					return `image_popup_content_${id}`;
				}
				if (ObjectTypesHelper.isReceiverObjectType(this.objectType)) {
					return `image_popup_receiver_${id}`;
				}
			}
			return `image_popup_0`;
		}

		private getTaskList() {
			if (this.actualItem.taskList == undefined)
				return [];
			return (JSON.parse(JSON.stringify(this.actualItem.taskList)) as Array<any>);
		}

		private getShowTags() {
			return (JSON.parse(JSON.stringify(this.actualItem.tags)) as Array<any>);
		}

		private gridColor(color: string): string {
            return 'background-color: ' + color + '; pointer-events: none;';
		}

		private goRight() {
			if (this.showNextIcon()) {
				this.nextPicture();
			}
		}

		private goLeft() {
            if (this.showPrevIcon()) {
                this.prevPicture();
            }
		}

		private showPrevIcon(): boolean {
			return this.actualIndex > 0;
		}

		private showNextIcon(): boolean {
			return (this.actualIndex + 1) < (this.listItems as Array<any>).length;
		}

		private prevPicture(): void {
			this.changePicture();
			this.actualIndex--;
			this.actualItem = (this.listItems as Array<any>)[this.actualIndex];
			this.idItem = this.actualItem.id;


			this.$forceUpdate();
		}

		private nextPicture(): void {
			this.changePicture();
			this.actualIndex++;
			this.actualItem = (this.listItems as Array<any>)[this.actualIndex];
			this.idItem = this.actualItem.id;

			this.$forceUpdate();
		}

		private closeWindow(): void {
			this.stopMedia();
            this.isDownloadVideo = false;
            this.showVideoTag = this.showAudioStreamTag = false;
			this.$bvModal.hide(this.id);
			document.body.classList.remove('modal-open');
			this.showLogoText(true);
		}

		//opetovne zobrazeni paticky
		showLogoText(show: boolean) {
            const doc = window.document;
            const element = doc.getElementById("trustlabLogoText");
            //@ts-ignore
            element.style.display = show ? "block" : "none";
		}

		private gotoDetailTask(id: string): void {
			this.showLogoText(true);
			this.$router.push({ name: 'TaskDetail', params: { id: id }, query: {id: id} });
		}

		private download(): void {
			if (this.contentService != null) {
				this.isBusy = true;
				if (this.isContentModal && this.idItem > 0) {
					this.contentService.getOriginalFileById(this.idItem).then((response) => {
						this.createFile(response);
						this.isBusy = false;
					}).catch((error) => {
						if (this.fileNotFound(error)) {
							this.showErrorMessage('Soubor nenalezen');
						} else {
							this.showErrorMessage(JSON.stringify(error.response.data.errors));
						}
						this.isBusy = false;
					});
				}
			}
		}

		private showErrorMessage(errorMessage: string) {
			this.alertModalTitle = 'Chyba';
			this.alertModalContent = errorMessage;
			this.$bvModal.show(this.alertModalId);
		}

		//VaPTODO - pokud to bude fungovat, tak to zkusit presunout do filehelper.ts a volat to odtud a i z jinych mist, kde se stahuje soubor
		private fileNotFound(response: any): boolean {
			if (response.status) {
				return response.status == 404;
			}
			return false;
		}

		//VaPTODO - pokud to bude fungovat, tak to zkusit presunout do filehelper.ts a volat to odtud a i z jinych mist, kde se stahuje soubor
		createFile(response: AxiosResponse<any>) {
			var filename = "";
			var disposition = response.headers["content-disposition"];
			var blob = new Blob([response.data]);

			if (disposition && (disposition.indexOf('inline') !== -1 || disposition.indexOf('attachment') !== -1)) {
				var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
				var matches = filenameRegex.exec(disposition);
				if (matches != null && matches[1]) {
					filename = matches[1].replace(/['"]/g, '');
				}
			}
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', filename)
			document.body.appendChild(link)
			link.click()
		}

		deleteItem() {
			this.$emit('deleteFrom', this.idItem);
			//nechceme skryti popupu....
		}

		showDownloadButton(): boolean {
			if (this.actualItem == null) {
				return false;
            }
			return this.actualItem.canDownloadFile;
		}

		gotoDetail(): void {	
            this.showLogoText(true);
			this.$bvModal.hide(this.id);
			if (ObjectTypesHelper.isContentObjectType(this.objectType)) {
				this.$router.push({ name: 'ContentDetail', params: { id: this.idItem.toString() }, query: { id: this.idItem.toString() } });
			}
			if (ObjectTypesHelper.isReceiverObjectType(this.objectType)) {
				this.$router.push({ name: 'ReceiverDetail', params: { id: this.idItem.toString() }, query: { id: this.idItem.toString() }  });
			}
		}

		setSelected(id: number, list: any, objectType: any, orderBy: string, orderDesc: boolean) {
			this.orderBy = orderBy;
			this.orderDesc = orderDesc;

			this.listItems = this.itemsDataOrdered(list);
			this.actualItem = (this.listItems as Array<any>).filter(c => c.id == id)[0];
			this.idItem = id;
			this.actualIndex = (this.listItems as Array<any>).indexOf(this.actualItem);
			this.objectType = objectType;
		}

		itemsDataOrdered(list: any) {
			var items = (list as Array<any>);

			if (this.orderDesc) {
				return items.sort((a: any, b: any) => (b[this.orderBy] ? b[this.orderBy].localeCompare(a[this.orderBy]) : -1));
			}
			else {//nahoru sipka asc
				return items.sort((a: any, b: any) => (a[this.orderBy] ? a[this.orderBy].localeCompare(b[this.orderBy]) : -1));
			}

		}

	}

